import { UrlProvider } from './UrlProvider';

export class UrlProviderInstanceManager {
    private static _instance?: UrlProvider;

    static getInstance(): UrlProvider {
        if (!UrlProviderInstanceManager._instance)
            UrlProviderInstanceManager._instance = new UrlProvider();

        return UrlProviderInstanceManager._instance;
    }
}

// Crea il provider e carica gli url
export const urlProvider = UrlProviderInstanceManager.getInstance();